import { defineStore } from 'pinia'
import { ref } from 'vue'
import { useStorage } from '@vueuse/core'
import axios from 'axios'

export const useAuthStore = defineStore('auth', () => {
  const user = useStorage('userDetails', {
    username: null,
    name: null,
    employeeType: null,
    isProistamenosApoixografitis: false,
  })

  const isLoggedIn = ref(false)

  const fetchUser = async () => {
    try {
      await axios('/auth/userDetails')
      return { isSuccess: true }
    } catch {
      return { isSuccess: false }
    }
  }

  const reset = () => {
    user.value = {
      username: null,
      name: null,
      employeeType: null,
      roles: []
    }
    isLoggedIn.value = false
  }

  const logout = async () => {
    try {
      await axios('/auth/logout')

      return {
        isSuccess: true
      }
    } catch {
      return {
        isSuccess: false
      }
    }
  }

  const initializeUsingPrincipalCookie = () => {
    //if (user.value.username === null && user.value.name === null && user.value.employeeType === null) {
    const value = `; ${document.cookie}`
    const parts = value.split(`; principal=`)
    if (parts.length === 2) {
      let principalBase64 = parts.pop().split(';').shift()
      if (principalBase64 === null) {
        reset()
        return
      }
      try {
        const decodedString = decodeURIComponent(
          Array.prototype.map
            .call(
              atob(principalBase64),
              (c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2)
            )
            .join('')
        )
        const userDetails = JSON.parse(decodedString)

        user.value.username = userDetails.username || null
        user.value.name = userDetails.name || null
        user.value.employeeType = userDetails.employeeType || null
        user.value.roles = userDetails.roles || []
        user.value.isProistamenosApoixografitis = userDetails.roles.includes(
          'ROLE_PROISTAMENOS_APOIXOGRAFISIS'
        )
        isLoggedIn.value = !!userDetails.username
      } catch (error) {
        console.error('Failed to parse user details from principal cookie:', error)
      }
    }
    //}
  }

  return {
    user,
    isLoggedIn,
    fetchUser,
    logout,
    reset,
    initializeUsingPrincipalCookie
  }
})
